import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useLocation } from "react-router";
import { getUserRequest, buildReport } from "../../api";
import "./test.css";

const Test = () => {
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const userRequest = params.get("user_request");
  const persona = params.get("persona");
  const userRequestQuery = useQuery({
    queryKey: ["userRequest", { userRequest }],
    queryFn: ({ queryKey }) => {
      const { userRequest } = queryKey[1];
      return getUserRequest({ id: userRequest });
    },
    enabled: !!userRequest, // Only run if userRequest is provided
  });
  const reportQuery = useQuery({
    queryKey: ["report", { userRequest: userRequestQuery.data?.user_request, persona }],
    queryFn: async ({ queryKey }) => {
      const { userRequest, persona } = queryKey[1];
      const result = await buildReport({ userRequest, persona });
      return JSON.stringify(result, null, 2);
    },
    enabled: !!userRequestQuery.data?.user_request, // Only run if userRequest is provided
  });

  return (
    <div className="test_wrapper">
      <h1>User Request</h1>
      <textarea
        value={userRequestQuery.data?.user_request || userRequestQuery.status}
        readOnly
      ></textarea>
      <h1>Report</h1>
      <textarea value={reportQuery.data || reportQuery.status} readOnly></textarea>
    </div>
  );
};

export default Test;
